import React, { useState, useEffect, useRef } from "react";
import { theme } from "../../../index";
import { Shimmer } from "react-shimmer";
import ClipLoader from "react-spinners/ClipLoader";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import {
  add_subtopics_category,
  edit_subtopics_category,
  deleteSubTopicsCategory,
  fetch_subtopics_category,
} from "../../../api/testSeries/category";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import CategorySubTopicsRow from "./CategorySubTopicsRow";

const CategorySubTopics = (props) => {
  const params = useParams();
  const [offset, setOffset] = useState(0);
  const [showShimmer, setShowShimmer] = useState(false);
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [loadingAddCategory, setLoadingAddCategory] = useState(false);
  const [isLast, setIsLast] = useState(false);
  const [categoryData, setCategoryData] = useState([]);
  const [showLoader, setShowLoader] = useState(true);
  const [addCategoryData, setAddCategoryData] = useState({});
  const [mode, setMode] = useState();
  const [editIndex, setEditIndex] = useState();
  const insDetails = useSelector((state) => state.ins.insDetails);
  const insId = 1;
  const [imageFile, setImageFile] = useState("");
  let fileRef = useRef(null);
  const [imagePreview, setImagePreview] = useState("");

  const history = useHistory();
  const addCategoryBtnHandler = async () => {
    setLoadingAddCategory(true);
    addCategoryData["testChapterTopic"] = { id: params.id };
    // const imageObj = await s3upload(
    //   imageFile,
    //   () => {},
    //   "institutes/" +
    //     insDetails?.name.replace(/[^a-zA-Z]/g, "") +
    //     "/" +
    //     "/image"
    // );
    // addCategoryData["image"] = imageObj.filePath;
    const response = await add_subtopics_category(addCategoryData);
    if (response.status) {
      addCategoryData["id"] = response.data.id;
      const arr = [...categoryData];
      arr.push(addCategoryData);
      setCategoryData(arr);
      setAddCategoryData({});
      setLoadingAddCategory(false);
    }
    setIsAddModalVisible(false);
  };

  const editCategoryBtnHandler = async () => {
    setLoadingAddCategory(true);
    // addCategoryData["insId"] = insId;
    // if (imageFile) {
    //   if (categoryData[editIndex].image) {
    //     s3Delete(categoryData[editIndex].image);
    //   }
    //   const imageObj = await s3upload(
    //     imageFile,
    //     () => {},
    //     "institutes/" + insDetails?.name.replace(/[^a-zA-Z]/g, "") + "/image"
    //   );
    //   addCategoryData["image"] = imageObj.filePath;
    // }

    delete addCategoryData.subSubTopics;
    addCategoryData["testChapterTopic"] = { id: params.id };
    addCategoryData["id"] = addCategoryData.id;
    const response = await edit_subtopics_category(
      addCategoryData.name,
      addCategoryData.bookPageNo,
      addCategoryData.id
    );
    if (response.status) {
      const arr = [...categoryData];
      arr[editIndex] = addCategoryData;
      setCategoryData(arr);
      setAddCategoryData({});
      setLoadingAddCategory(false);
    }
    setIsAddModalVisible(false);
  };
  const getTestSeriesCategory = async () => {
    const response = await fetch_subtopics_category(params.id);
    if (response.status) {
      setCategoryData(response.data);
      setIsLast(response.data.last);
    } else {
      console.log("Error in fetching");
    }
    setShowLoader(false);
  };
  useEffect(() => {
    setShowLoader(true);
    getTestSeriesCategory();
  }, [offset]);

  const handleInputChange = (e) => {
    const obj = { ...addCategoryData };
    obj[e.target.name] = e.target.value;
    setAddCategoryData(obj);
  };

  const deleteBtnHandler = async (id, index) => {
    if (window.confirm("Are you sure you want to delete this Topic?")) {
      //   if (categoryData[index].image) {
      //     s3Delete(categoryData[index].image);
      //   }

      const response = await deleteSubTopicsCategory(id);

      if (response.status) {
        const arr = [...categoryData];
        arr.splice(index, 1);
        setCategoryData(arr);
      } else {
        console.log("Error in fetching");
      }
    }
  };

  const tiggerClickOnFile = () => {
    fileRef.click();
  };

  const fileOnChange = (event) => {
    var url = URL.createObjectURL(event.target.files[0]);
    setImagePreview(url);
    setImageFile(event.target.files[0]);
    console.log("file cat:", event.target.files[0]);
  };
  const setEditDetails = (link) => {
    setImagePreview(link);
    setMode("edit");
  };
  const setAddDetails = () => {
    setImagePreview("");
    setMode("add");
  };
  // console.log("category data: ", categoryData)
  return (
    <div>
      <div class="page-breadcrumb  d-md-flex align-items-center mb-3">
        <div class="breadcrumb-title pr-3">Sub-Topics</div>
        <div class="pl-3">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb mb-0 p-0">
              <li class="breadcrumb-item">
                <a href="javascript:;">
                  <i class="bx bx-home-alt"></i>
                </a>
              </li>
            </ol>
          </nav>
        </div>
        <div class="ml-auto">
          <div class="btn-group">
            <button
              type="button"
              class="btn btn-danger"
              style={{ marginRight: 5 }}
              onClick={() => {
                setMode("add");
                setIsAddModalVisible(true);
                setAddCategoryData({});
                setAddDetails();
              }}
            >
              Add Sub Topics
            </button>
          </div>
          {/* <button type="button" class="btn btn-dark" onClick={() => history.goBack()}>Go Back</button> */}
        </div>
      </div>

      {showLoader ? (
        <Shimmer width={"100%"} height={40} />
      ) : (
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <table
                class="table table-striped table-bordered mb-0"
                id="table1"
              >
                <thead class="thead-dark">
                  <tr>
                    <th align="center">#</th>
                    <th align="center">Title</th>
                    <th align="center">Book Page Number</th>
                    {/* <th align="center">Discount</th>
                    <th align="center">Image</th>
                    <th align="center">Status</th> */}
                    <th align="center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {showShimmer ? (
                    <td colspan="9">
                      <Shimmer width={"100%"} height={40} />
                    </td>
                  ) : (
                    categoryData &&
                    categoryData.map((row, i) => (
                      <CategorySubTopicsRow
                        setMode={setMode}
                        setAddCategoryData={setAddCategoryData}
                        setIsAddModalVisible={setIsAddModalVisible}
                        row={row}
                        index={i}
                        deleteBtnHandler={deleteBtnHandler}
                        setEditIndex={setEditIndex}
                        setEditDetails={setEditDetails}
                      />
                    ))
                  )}
                </tbody>
              </table>
              <br />
              <div>
                {offset == 0 ? null : !showLoader ? (
                  <button
                    aria-label="delete"
                    onClick={() => setOffset(offset - 1)}
                    className="btn btn-dark mr-1"
                  >
                    Previous
                  </button>
                ) : null}

                {isLast ? null : !showLoader ? (
                  <button
                    aria-label="delete"
                    onClick={() => setOffset(offset + 1)}
                    className="btn btn-primary mr-1"
                  >
                    Next
                  </button>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      )}
      <Modal
        size="lg"
        show={isAddModalVisible}
        onHide={() => setIsAddModalVisible(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        style={{ zIndex: 10000 }}
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            {mode == "add" ? "Add Sub Topic " : "Edit Sub Topic "}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Form.Group as={Col} md="6" className="position-relative">
                <Form.Label> Name</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  onChange={handleInputChange}
                  value={addCategoryData["name"]}
                  required
                />
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} md="6" className="position-relative">
                <Form.Label>Book Page Number</Form.Label>
                <Form.Control
                  type="text"
                  name="bookPageNo"
                  onChange={handleInputChange}
                  value={addCategoryData["bookPageNo"]}
                  required
                />
              </Form.Group>
              {/* <Form.Group as={Col} md="6" className="position-relative">
                <Form.Label>Discount Amt</Form.Label>
                <Form.Control
                  type="text"
                  name="discountAmt"
                  onChange={handleInputChange}
                  value={addCategoryData["discountAmt"]}
                  required
                />
              </Form.Group> */}
            </Row>
            {/* <Row> */}
            {/* <div className="form-row">
              <div className="col-6 col-lg-6">
                <label>Image </label>
                <input
                  className="form-control"
                  type="file"
                  ref={(ref) => (fileRef = ref)}
                  onChange={(e) => {
                    fileOnChange(e);
                  }}
                  style={{ visibility: "hidden" }}
                />
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={tiggerClickOnFile}
                >
                  Choose Image
                </button>
              </div>
              <div className="col-6 col-lg-6 mt-3">
                {imagePreview ? (
                  <img
                    src={
                      imagePreview
                        ? imagePreview
                        : "http://placehold.it/500/500"
                    }
                    className="img-responsive w-50 h-50"
                  />
                ) : null}
              </div>
            </div> */}
            {/* </Row> */}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setIsAddModalVisible(false)}
            style={{
              backgroundColor: theme.greyColor,
              color: theme.primaryColor,
            }}
          >
            Close
          </Button>
          <Button
            type="submit"
            variant="primary"
            style={{
              backgroundColor: theme.darkPurpleColor,
              marginLeft: 10,
              color: theme.primaryColor,
            }}
            onClick={() =>
              window.confirm(
                mode == "add"
                  ? "Are You Sure You Want To Add?"
                  : "Are You Sure You Want To Edit?"
              )
                ? mode == "add"
                  ? addCategoryBtnHandler()
                  : editCategoryBtnHandler()
                : console.log("no")
            }
          >
            {loadingAddCategory ? (
              <ClipLoader
                color={theme.primaryColor}
                loading={loadingAddCategory}
              />
            ) : mode == "add" ? (
              "Add"
            ) : (
              "Edit"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CategorySubTopics;
